<div class="is-loading-answer" [ngStyle]="getStyle()" [@inOutAnimation] *ngIf="isLoading">{{ text }}</div>
